import FilterButton from "@Generic/buttons/FilterButton";
import React from "react";
import usePopularFilters from "@SearchResults/features/sidebar/features/popularFilters/hooks/usePopularFilters";
import useDispatchFilterEvents from "@SearchResults/features/sidebar/hooks/useDispatchFilterEvent";
import {Colors} from "@Styles/Colors.style";
import IconSlimArrowRight from "@Icons/IconSlimArrowRight";
import {useTranslation} from "@Translation/hooks/useTranslation";

function DirectFilter() {
    const label = useTranslation("search_results.filter_by.popular_filters.filters.direct")
    const {isActive, setActive} = usePopularFilters("direct")

    const handleOnBlur = useDispatchFilterEvents('webDiscountFilter', isActive.toString());

    return (
        <FilterButton
            label={label}
            active={isActive}
            icon={(
                <IconSlimArrowRight
                    width="20"
                    height="20"
                    fill={isActive ? Colors.primaryColor : Colors.neutralDarkestColor}
                />
            )}
            onClick={setActive}
            onBlur={handleOnBlur}
        />
    );
}

export default DirectFilter;